import { ClaimedTask } from '../../../core/tasks/models/claimed-task-object.model';
import { SearchResult } from '../../search/search-result.model';

/**
 * Represents a search result object of an Approved ClaimedTask object
 */
export class ClaimedApprovedTaskSearchResult extends SearchResult<ClaimedTask> {
}
